import { render, staticRenderFns } from "./FrontendAppComponent.vue?vue&type=template&id=33004e5e&"
import script from "./FrontendAppComponent.vue?vue&type=script&lang=js&"
export * from "./FrontendAppComponent.vue?vue&type=script&lang=js&"
import style0 from "@/styles/index.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports